import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';

import { IdName } from '@core/model/id-name';

@Component({
  selector: 'app-rapi-select',
  templateUrl: './rapi-select.component.html',
  styleUrls: ['./rapi-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RapiSelectComponent),
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RapiSelectComponent),
      multi: true,
    },
  ],
})
export class RapiSelectComponent implements OnInit, ControlValueAccessor, OnDestroy {
  form: FormGroup;
  subscriptions: Subscription[] = [];
  @Input() items: IdName[];
  @Input() requiredMSG: string;
  @Input() label: string;

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      selectedItem: ['', Validators.required],
    });

    this.subscriptions.push(
      this.form.valueChanges.subscribe((value) => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngOnInit() {
    this.requiredMSG = this.requiredMSG ? this.requiredMSG : 'Requerido';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  get selectedItemControl() {
    return this.form.controls.selectedItem;
  }

  get value(): IdName {
    return this.form.value;
  }

  set value(value: IdName) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  validate(_: FormControl) {
    return this.form.valid ? null : { item: { valid: false } };
  }
}
